/*
 * Copyright (c) 2022-2025.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React from 'react';
import PropTypes from 'prop-types';
import DisplayIcon from "../Icons/DisplayIcon.jsx";
import {motion} from "motion/react";
import TextTruncate from "../TextTruncate.jsx";


/*
 * This Component Displays a Button with an icon
 * @example    <ButtonComponent text={"Add new"} activeColor={"bg-green-50"} iconHoverColor={"text-green-500"} />
 */
class ButtonComponent extends React.PureComponent {
    constructor() {
        super();

        this.state = {
            isLoading: false
        }
    }


    render() {
        return (
            <motion.button type="button" whileTap={{scale: 0.9}}
                           id={this.props.id}
                           className={`text-stone-700 py-1.5 px-2.5 focus:ring-blue-300 text-sm border border-gray-300  group select-none inline-flex flex-none  shadow-sm rounded-md bg-white hover:bg-stone-50 focus:outline-none focus-visible:bg-blue-50 focus-visible:ring-1 transition duration-200 items-center ease-in-out active:${this.props.activeColor} ${this.props.className}`}
                           onClick={async () => {
                               this.setState({isLoading: true})
                               if (this.props.onClick !== undefined) {
                                   await this.props.onClick()
                               }
                               this.setState({isLoading: false})
                           }}>
                {this.state.isLoading ? (
                    <DisplayIcon iconName={"Spinner"}
                                 className="w-5 h-5 mr-2 animate-spin shrink-0 will-change-transform"/>) : (
                    <DisplayIcon iconName={this.props.iconName}
                                 className={`w-5 h-5 mr-2 group-hover:${this.props.iconHoverColor}`}/>)}
                <span className={"shrink"}><TextTruncate>{this.props.text}</TextTruncate> </span>
            </motion.button>)
    };
}

export default ButtonComponent;

ButtonComponent.propTypes = {
    /**
     * The text of the Button
     */
    text: PropTypes.string.isRequired,
    /**
     * The event if the button is pressed
     * @example (value)=>{console.log(value)}
     */
    onClick: PropTypes.func,
    /**
     * The hover color of the icon
     * @example text-green-500
     * @default text-gray-100
     */
    iconHoverColor: PropTypes.string,
    /**
     * The color if the button is pressed
     *  @example bg-green-50
     *  @default bg-gray-100
     */
    activeColor: PropTypes.string,
    /**
     * The color if the button is pressed
     *  @example IoIosAdd
     *  @default IoIosAdd
     */
    iconName: PropTypes.string,
    className: PropTypes.string,


}

ButtonComponent.defaultProps = {
    text: '',
    iconHoverColor: 'text-gray-300',
    activeColor: 'bg-gray-100',
    iconName: 'IoIosAdd'
}